import { createApp } from 'vue'
import './css/theme.less'
import './css/common.less'
import App from './App.vue'
import i18n from '@/languages/i18n'
import { initializeVirtualKeyboardAppearance } from '@/service/keyboard_appearance'
import { initializeSoftwareTheme } from '@/service/software_theme'
import { initializeCustomBackground } from '@/service/custom_background'
import { setDebug } from '../libs/debug'
setDebug()
initializeSoftwareTheme()
initializeCustomBackground()
initializeVirtualKeyboardAppearance()
createApp(App).use(i18n).mount('#app')
